import { Card } from "@/libraries/design/components";
import { cardLogoLockups } from "@/libraries/design/components/card/src/card";
import { RichTextComponent } from "@/libraries/design/utils";
import { useLocalizedHref } from "@/libraries/web-framework";

export interface UniformCardProps {
    alignment?: "start" | "center";
    orientation?: "vertical" | "horizontal";
    columns?: 10 | 12;
    background?: "light" | "dark";
    eyebrow?: string;
    logo?: keyof typeof cardLogoLockups;
    title?: string;
    titleAs?: "h2" | "h3" | "h4" | "h5" | "p";
    body?: string;
    richText?: string;
    linkText?: string;
    linkUrl?: string;
    imageUrl?: string;
    imageAlt?: string;
    iconUrl?: string;
    iconSize?: "x-small" | "small" | "medium" | "large";
    spotIllustrationUrl?: string;
}

const getBodyText = (props: UniformCardProps) => {
    if (!props.body && !props.richText) {
        return undefined;
    }

    if (props.richText) {
        return <RichTextComponent text={props.richText} />;
    }

    return props.body;
};

const UniformCard = (props: UniformCardProps) => {
    const localizedHref = useLocalizedHref(props.linkUrl?.toString() ?? "");

    return (
        <Card
            align={props.alignment}
            orientation={props.orientation}
            columns={props.columns}
            background={props.background}
            eyebrow={props.eyebrow ? props.eyebrow : undefined}
            logo={props.logo}
            title={props.title ? props.title : undefined}
            titleAs={props.titleAs}
            body={getBodyText(props)}
            callToAction={
                props.linkUrl && props.linkText
                    ? {
                          text: props.linkText,
                          href: localizedHref,
                          dataEventProps: {
                              "data-product-key": "uniform",
                              "data-event-component": "linkButton",
                              "data-event-container": "card",
                              "data-event": "clicked"
                          }
                      }
                    : undefined
            }
            image={
                props.imageUrl
                    ? {
                          image: {
                              src: props.imageUrl,
                              alt: props.imageAlt ?? ""
                          }
                      }
                    : undefined
            }
            icon={
                props.iconUrl
                    ? {
                          linkedIcon: {
                              url: props.iconUrl,
                              size: props.iconSize
                          }
                      }
                    : undefined
            }
            spotIllustrationUrl={props.spotIllustrationUrl}
        />
    );
};

export default UniformCard;
